export const StatusCircle = ({
  className,
  size,
  style,
}: {
  className?: string
  size?: number
  style?: React.CSSProperties
}) => (
  <svg
    className={className}
    width={size}
    height={size}
    viewBox="0 0 10 10"
    xmlns="http://www.w3.org/2000/svg"
    style={style}
  >
    <circle cx="5" cy="5" r="5" />
  </svg>
)
